import type { ComponentProps } from 'react';
import Button from '@/components/UI/Button';

type LegacyButtonProps = Omit<
  ComponentProps<typeof Button>,
  'appearance' | 'shape' | 'variant'
> & {
  chip?: boolean;
  outline?: boolean;
  shape?: ComponentProps<typeof Button>['shape'];
  variant?: ComponentProps<typeof Button>['variant'] | 'ghost';
};

export default function UnistylesButton({
  chip,
  outline,
  shape,
  variant,
  ...props
}: LegacyButtonProps) {
  const appearance = outline
    ? 'outline'
    : variant === 'ghost'
      ? 'ghost'
      : 'solid';
  const nextVariant = variant === 'ghost' ? 'primary' : variant;

  return (
    <Button
      {...props}
      appearance={appearance}
      shape={chip ? 'pill' : shape}
      variant={nextVariant}
    />
  );
}
